import { useMutation, useQueryClient } from "@tanstack/react-query";
import { merchantKeys } from "Api/Queries/Merchants/useGetMerchantQuery";
import { deleteMerchantsPublicIDFacilitiesFacilityPublicIDLogo } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = {
  merchantPublicID: string;
  facilityPublicID: string;
};

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useDeleteFacilityLogoMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ merchantPublicID, facilityPublicID }: Parameters) =>
        deleteMerchantsPublicIDFacilitiesFacilityPublicIDLogo(
          merchantPublicID,
          facilityPublicID,
        ),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: merchantKeys.all,
      });
      onSuccess?.();
    },
    onError,
  });
};
